// 权限体系
import moduleAppAddEdit from '@/views/permissionSystem/moduleApp/moduleAppAddEdit';
import moduleAppList from '@/views/permissionSystem/moduleApp/moduleAppList';
import moduleAppDetail from '@/views/permissionSystem/moduleApp/moduleAppDetail';
import moduleAppIntDetail from '@/views/permissionSystem/moduleApp/moduleAppIntDetail';
import moduleAppIntApi from '@/views/permissionSystem/moduleApp/moduleAppIntApi';
import moduleAppSchool from '@/views/permissionSystem/moduleApp/moduleAppSchool';
import moduleAppScanConfigHelper from '@/views/permissionSystem/moduleApp/moduleAppScanConfigHelper';

import permission from '@/views/permissionSystem/permission/permission';

import roleList from '@/views/permissionSystem/role/roleList';
import roleAddEdit from '@/views/permissionSystem/role/roleAddEdit';

import moduleRolePermissionList from '@/views/permissionSystem/moduleRolePermission/moduleRolePermissionList';
import moduleRolePermissionAdd from '@/views/permissionSystem/moduleRolePermission/moduleRolePermissionAdd';
import moduleRolePermissionEdit from '@/views/permissionSystem/moduleRolePermission/moduleRolePermissionEdit';

import apiPermissionList from '@/views/permissionSystem/apiPermission/apiPermissionList';

// 套件体系
import suiteManageIndex from '@/views/suiteSystem/suiteManage/suiteManageIndex';
import suiteManageAdd from '@/views/suiteSystem/suiteManage/suiteManageAdd';
import suiteManageInfo from '@/views/suiteSystem/suiteManage/suiteManageInfo';
import suiteAppIndex from '@/views/suiteSystem/suiteApp/suiteAppIndex';
import suiteRoleIndex from '@/views/suiteSystem/suiteRole/suiteRoleIndex';

// 常用工具
import rolePermissionManage from '@/views/commonTool/rolePermissionManage';
import redisManageList from '@/views/commonTool/redisManageList';
import redisManageInfo from '@/views/commonTool/redisManageInfo';

// 外链系统
import outSystem from '@/views/commonTool/outSystem';

export default [
  // 权限体系
  {
    path: 'developmentSystem',
    redirect: 'developmentSystem/permissionSystem/moduleApp/moduleAppList'
  },
  {
    path: 'developmentSystem/permissionSystem/moduleApp/moduleAppList',
    component: moduleAppList,
      meta: {
          isCached: true
      }
  },
  {
    path: 'developmentSystem/permissionSystem/moduleApp/moduleAppAddEdit',
    component: moduleAppAddEdit
  },
  {
    path: 'developmentSystem/permissionSystem/moduleApp/moduleAppDetail',
    component: moduleAppDetail
  },
  {
    path: 'developmentSystem/permissionSystem/moduleApp/moduleAppIntDetail',
    component: moduleAppIntDetail
  },
    {
        path: 'developmentSystem/permissionSystem/moduleApp/moduleAppIntApi',
        component: moduleAppIntApi
    },
  {
    path: 'developmentSystem/permissionSystem/moduleApp/moduleAppSchool',
    component: moduleAppSchool
  },
  {
    path: 'developmentSystem/permissionSystem/moduleApp/moduleAppScanConfigHelper',
    component: moduleAppScanConfigHelper
  },
  {
    path: 'developmentSystem/permissionSystem/permission/permission',
    component: permission
  },
  {
    path: 'developmentSystem/permissionSystem/role/roleList',
    component: roleList,
    meta: {
        isCached: true
    }
  },
  {
    path: 'developmentSystem/permissionSystem/role/roleAddEdit',
    component: roleAddEdit
  },
  {
    path: 'developmentSystem/permissionSystem/moduleRolePermission/moduleRolePermissionList',
    component: moduleRolePermissionList,
      meta: {
          isCached: true
      }
  },
  {
    path: 'developmentSystem/permissionSystem/moduleRolePermission/moduleRolePermissionAdd',
    component: moduleRolePermissionAdd
  },
  {
    path: 'developmentSystem/permissionSystem/moduleRolePermission/moduleRolePermissionEdit',
    component: moduleRolePermissionEdit
  },
  {
    path: 'developmentSystem/permissionSystem/apiPermission/apiPermissionList',
    component: apiPermissionList
  },

  // 套件体系
  {
    path: 'developmentSystem/suiteSystem/suiteManage/suiteManageIndex',
    component: suiteManageIndex
  },
  {
    path: 'developmentSystem/suiteSystem/suiteManage/suiteManageAdd',
    component: suiteManageAdd
  },
  {
    path: 'developmentSystem/suiteSystem/suiteManage/suiteManageInfo',
    component: suiteManageInfo
  },
  {
    path: 'developmentSystem/suiteSystem/suiteApp/suiteAppIndex',
    component: suiteAppIndex
  },
  {
    path: 'developmentSystem/suiteSystem/suiteRole/suiteRoleIndex',
    component: suiteRoleIndex
  },

  // 常用工具
  {
    path: 'developmentSystem/commonTool/rolePermissionManage',
    component: rolePermissionManage
  },
  {
    path: 'developmentSystem/commonTool/redisManageList',
    component: redisManageList
  },
  {
    path: 'developmentSystem/commonTool/redisManageInfo',
    component: redisManageInfo
  },

  // 外链系统
  {
    path: 'developmentSystem/outSystem',
    component: outSystem
  }
]



// WEBPACK FOOTER //
// ./src/router/modules/developmentSystem.js